/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { differenceInCalendarDays, format } from 'date-fns';
import { Fatura_Parc, useInvoicesTable } from '../../../context/TableContext';
import { RowItem } from './styles';

interface ReadOnlyProps {
  fatura_parc: Fatura_Parc;
}

export function ReadOnlyRow({ fatura_parc }: ReadOnlyProps) {
  const [vencimento, setVencimento] = useState(0);
  const [inicial, setInicial] = useState(0);
  const [final, setFinal] = useState(0);

  const { page } = useInvoicesTable();

  function calcFinalInicial() {
    fatura_parc.parcelas.sort((a, b) => a.nroparc - b.nroparc);
    setInicial(fatura_parc.parcelas[0].nroparc);
    setFinal(fatura_parc.parcelas[fatura_parc.parcelas.length - 1].nroparc);
  }

  function calcVencimento() {
    const result = differenceInCalendarDays(
      new Date(fatura_parc.parcelas[1]?.vencimento), //data da segunda parcela
      new Date(fatura_parc.parcelas[0]?.vencimento), // data da primeira parcela
    );
    setVencimento(result);
  }

  function formatoDatas(data: string) {
    if (page === 'register') {
      return data.split('-').reverse().join('/');
    } else {
      const dataFormatada = format(new Date(data), 'dd/MM/yyyy');
      return dataFormatada;
    }
  }

  function stringTipoDoc(tipoDoc: number) {
    switch (tipoDoc) {
      case 1:
        return 'Carnê';
      case 2:
        return 'Cheque';
      case 3:
        return 'N.Promissória';
      case 4:
        return 'CDC';
      case 5:
        return 'Duplicata';
      case 6:
        return 'Cartão de Crédito';
      default:
        return 'Contrato';
    }
  }

  useEffect(() => {
    calcFinalInicial();
    calcVencimento();
  }, [fatura_parc]);

  return (
    <>
      <RowItem>
        <p>{fatura_parc.fatura.documento}</p>
      </RowItem>

      <RowItem>
        <p>{stringTipoDoc(fatura_parc.fatura.tipodoc)}</p>
      </RowItem>

      <RowItem>
        <p>{inicial}</p>
      </RowItem>

      <RowItem>
        <p>{final}</p>
      </RowItem>

      <RowItem id="open">
        <p>{fatura_parc.fatura.qtdeparc}</p>
      </RowItem>

      <RowItem id="open">
        <p>{formatoDatas(fatura_parc.fatura.data1parc)}</p>
      </RowItem>

      <RowItem>
        <p>{vencimento ? vencimento : 0}</p>
      </RowItem>

      <RowItem>
        <p>
          {new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(fatura_parc.fatura.valorparc)}
        </p>
      </RowItem>
    </>
  );
}
